import API from '@/api'
import { SELLER_CODE_ATTRIBUTE, getSellerCode } from '@/services/sellerCodeStorage'
// import RouterService from '../services/routerService'
// import CustomAttributesBase from '@/services/CustomAttributesBase'
// import EventBus from '@/helpers/eventBus'
// import Tracking from '@/services/tracking'
// import jsonp from 'jsonp'

const state = {
  CustomAttributes: []
}
const getters = {
  CustomAttributes: function (state) {
    let currentNoteAttributes = state.Checkout.note_attributes ? state.Checkout.note_attributes : []
    return [
      ...currentNoteAttributes,
      ...state.CustomAttributes
    ]
  }
}
const actions = {
  async SetCustomAttribute ({ commit, getters, dispatch }, [...args]) {
    commit('UpdateCustomAttributesState', [...args].slice(0, 2))
  },
  async SendCustomAttributes ({ rootState, state, commit, getters, dispatch }) {
    let $checkout = rootState.Checkout.Checkout
    dispatch('setCheckoutStatus', {
      CustomAttributes: {
        create: 'LOADING'
      }
    })

    await API.put(`/CheckOuts/${$checkout.id}/NoteAttributes`, state.CustomAttributes)
      .then(response => {
        dispatch('setCheckoutStatus', {
          CustomAttributes: {
            create: 'IDLE'
          }
        })
        return commit('UpdateCheckoutState', {
          ...getters.Checkout,
          note_attributes: response.data.data.note_attributes
        })
      })
      .catch((e) => {
        console.log(e)
        console.log(e.message)
        dispatch('setCheckoutStatus', {
          CustomAttributes: {
            create: 'ERROR'
          }
        })
        dispatch('_buildErrorAlert', {
          title: 'Erro no SetCustomAttributes',
          error: `Ocorreu um erro com a criação do seu carrinho: ${e}`
        })
        dispatch('setAnalyticsError', { id: `${$checkout.id}`, method: 'SetCustomAttributes', error: e.message, fatal: true })
        commit('UpdateCustomAttributesState', null)
      })
  },
  async DeleteCustomAttribute ({ rootState, state, commit, getters, dispatch }, attributeName) {
    let $checkout = rootState.Checkout.Checkout
    dispatch('setCheckoutStatus', {
      CustomAttributes: {
        delete: 'LOADING'
      }
    })

    await API.delete(`/CheckOuts/${$checkout.id}/NoteAttributes/${attributeName}`)
      .then(response => {
        commit('RemoveCustomAttributeState', attributeName)
        dispatch('setCheckoutStatus', {
          CustomAttributes: {
            delete: 'IDLE'
          }
        })
        return commit('UpdateCheckoutState', {
          ...getters.Checkout,
          note_attributes: response.data.data.note_attributes
        })
      })
      .catch((e) => {
        console.log(e)
        console.log(e.message)
        dispatch('setCheckoutStatus', {
          CustomAttributes: {
            delete: 'ERROR'
          }
        })
        dispatch('_buildErrorAlert', {
          title: 'Erro no SetCustomAttributes',
          error: `Ocorreu um erro com a criação do seu carrinho: ${e}`
        })
        dispatch('setAnalyticsError', { id: `${$checkout.id}`, method: 'SetCustomAttributes', error: e.message, fatal: true })
        commit('UpdateCustomAttributesState', null)
      })
  },
  async EnsureSellerCodeAttribute ({ rootState, dispatch }) {
    const $checkout = rootState.Checkout.Checkout
    const storedSellerCode = getSellerCode($checkout.id)
    if (!storedSellerCode) return
    const currentSellerCode = ($checkout.note_attributes || [])
      .find(attribute => attribute.name === SELLER_CODE_ATTRIBUTE)
    if (currentSellerCode && currentSellerCode.value === storedSellerCode) return
    try {
      await dispatch('SetCustomAttribute', [SELLER_CODE_ATTRIBUTE, storedSellerCode])
      await dispatch('SendCustomAttributes')
    } catch (e) {
      dispatch('setAnalyticsError', { id: `${$checkout.id}`, method: 'EnsureSellerCodeAttribute', error: e.message, fatal: false })
    }
  },
  async UpdateCustomAttributesState ({ commit }, value) {
    commit('UpdateCustomAttributesState', value)
  }

}
const mutations = {
  UpdateCustomAttributesState: function (state, args) {
    let $currentAttribute = { name: args[0], value: args[1] }
    let $attributeToBeChanged = state.CustomAttributes.findIndex(attr => attr.name === args[0])
    if ($attributeToBeChanged !== -1) {
      state.CustomAttributes[$attributeToBeChanged] = $currentAttribute
    } else {
      state.CustomAttributes.push($currentAttribute)
    }
    state.CustomAttributes = [...state.CustomAttributes]
  },
  RemoveCustomAttributeState: function (state, attributeName) {
    state.CustomAttributes = state.CustomAttributes.filter(attr => attr.name !== attributeName)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
